var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4372 0H3.56283C1.5983 0 0 1.5983 0 3.56283V20.4371C0 22.4017 1.5983 24 3.56283 24H15.1052C16.2108 24 17.2501 23.5695 18.0319 22.7877L22.7877 18.0319C23.5695 17.2502 24 16.2108 24 15.1053V3.56283C24 1.5983 22.4017 0 20.4372 0ZM3.56283 22.5938C2.3737 22.5938 1.40625 21.6263 1.40625 20.4372V3.56283C1.40625 2.3737 2.3737 1.40625 3.56283 1.40625H20.4371C21.6263 1.40625 22.5938 2.3737 22.5938 3.56283V15.1052C22.5938 15.3521 22.5605 15.5938 22.4975 15.8257L20.6157 15.8277V4.08745C20.6157 3.69914 20.3009 3.38433 19.9125 3.38433H4.08745C3.69914 3.38433 3.38433 3.69914 3.38433 4.08745V19.9125C3.38433 20.3009 3.69914 20.6157 4.08745 20.6157H15.8253V22.4976C15.5934 22.5605 15.352 22.5938 15.1053 22.5938H3.56283ZM15.8253 18.6426V19.2094H4.79058V4.79058H19.2094V15.8292L18.6353 15.8298C17.0859 15.8313 15.8253 17.0931 15.8253 18.6426ZM17.2315 21.5994V18.6426C17.2315 17.8678 17.8619 17.2368 18.6368 17.236L21.5979 17.233L17.2315 21.5994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.44805 7.79897C8.08027 7.79897 7.72791 8.12236 7.74492 8.50209C7.76198 8.88305 8.05388 9.20522 8.44805 9.20522C8.81583 9.20522 9.16819 8.88183 9.15117 8.50209C9.13411 8.12114 8.84222 7.79897 8.44805 7.79897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 7.79897C11.6322 7.79897 11.2799 8.12236 11.2969 8.50209C11.3139 8.88305 11.6058 9.20522 12 9.20522C12.3678 9.20522 12.7201 8.88183 12.7031 8.50209C12.6861 8.12114 12.3942 7.79897 12 7.79897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0207 7.79897C15.6529 7.79897 15.3005 8.12236 15.3175 8.50209C15.3346 8.88305 15.6265 9.20522 16.0207 9.20522C16.3884 9.20522 16.7408 8.88183 16.7238 8.50209C16.7067 8.12114 16.4149 7.79897 16.0207 7.79897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.224 11.2969C9.85627 11.2969 9.50391 11.6203 9.52092 12C9.53799 12.381 9.82988 12.7031 10.224 12.7031C10.5918 12.7031 10.9442 12.3797 10.9272 12C10.9101 11.619 10.6182 11.2969 10.224 11.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.776 11.2969C13.4082 11.2969 13.0558 11.6203 13.0728 12C13.0899 12.381 13.3818 12.7031 13.776 12.7031C14.1437 12.7031 14.4961 12.3797 14.4791 12C14.462 11.619 14.1702 11.2969 13.776 11.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.44805 14.7948C8.08027 14.7948 7.72791 15.1182 7.74492 15.4979C7.76198 15.8789 8.05388 16.201 8.44805 16.201C8.81583 16.201 9.16819 15.8776 9.15117 15.4979C9.13411 15.117 8.84222 14.7948 8.44805 14.7948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12 14.7948C11.6322 14.7948 11.2799 15.1182 11.2969 15.4979C11.3139 15.8789 11.6058 16.201 12 16.201C12.3678 16.201 12.7201 15.8776 12.7031 15.4979C12.6861 15.117 12.3942 14.7948 12 14.7948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.552 14.7948C15.1842 14.7948 14.8318 15.1182 14.8488 15.4979C14.8659 15.8789 15.1578 16.201 15.552 16.201C15.9197 16.201 16.2721 15.8776 16.2551 15.4979C16.238 15.117 15.9461 14.7948 15.552 14.7948Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatch);
export default __webpack_public_path__ + "static/media/icon-patch.21bb84a1e2fe3eeb074481bab8252774.svg";
export { ForwardRef as ReactComponent };